import { useState } from "react";
import { LoadingOverlay } from "../../common/LoadingOverley/LoadingOverley";
import { FilterTableSync } from "./FilterTableSync";
import { TransactionSync } from "./TransactionSync";
import { CardToSyncStatusEnum, CardToSyncSourceEnum } from "magic-shared-types";
import { useGetCardToSyncByUserQuery } from "../../../services/myServer/CardToSync";
import { selectGame } from "../../../store/slices/global";
import { useSelector } from "react-redux";
import { DEFAULT_MAGIC_ID } from "../../../constant";

export const SectionSyncCards = () => {
  const game = useSelector(selectGame);
  const [page, setPage] = useState(1);
  const [market, setMarket] = useState<CardToSyncSourceEnum | undefined>(
    undefined
  );
  const [status, setStatus] = useState<CardToSyncStatusEnum | undefined>(
    undefined
  );
  const [name, setName] = useState("");

  const pageSize = 20;

  const {
    data: cardToSyncData,
    isLoading: cardToSyncLoading,
    refetch,
  } = useGetCardToSyncByUserQuery({
    page,
    pageSize,
    status: status || undefined,
    source: market,
    game_id: game?.id || DEFAULT_MAGIC_ID,
    name,
  });

  if (cardToSyncLoading) {
    return <LoadingOverlay />;
  }

  return (
    <>
      <FilterTableSync
        status={status}
        setStatus={setStatus}
        page={page}
        onPageChange={setPage}
        total={cardToSyncData?.pagination.total || 0}
        pageSize={pageSize}
        market={market}
        setMarket={setMarket}
        setName={setName}
      />
      {cardToSyncData && (
        <TransactionSync data={cardToSyncData?.data} refetch={refetch} />
      )}
    </>
  );
};
